import themeData from '@veasel/core/sass/themes/theme-suade.json';

export const themeColorsList = [
  'theme-main-dark',
  'theme-secondary',
  'theme-active',
  'theme-hover',
  'theme-secondary',
  'theme-secondary-50',
  'theme-secondary-light',
  'theme-background-main',
  'theme-background-secondary',
  'theme-approved',
  'theme-warning',
  'theme-error',
  'theme-topbar',
  'theme-light-hover',
];
export const getThemeColors = () => {
  const colors = {};
  themeData.colors.forEach((color) => {
    colors[color.cssName.split('--')[1]] = color.color;
  });
  return colors;
};

export const getLegacyColors = () => {
  return {
    black: '#333333',
    white: '#fefefe',
    gray: '#999999',
    lightgray: '#ededed',
    blue: '#3030d0',
    'focus-blue': '#4d74e0',
    red: '#f15942',
    green: '#009a53',
    orange: '#ff7300',
  };
};
